const statusOptions = [
  { id: 'pending', name: 'Pendente', color: 'status-critical' },
  { id: 'finished', name: 'Finalizada', color: 'status-ok' },
];

export default statusOptions;
